export default "__VITE_ASSET__DY8Ag83P__"